import { Schema } from "effect";
import { WorkingHours } from "./MeetingTimes.js";
export const RecruiterSettings = Schema.Struct({
    welcomeMatOptions: Schema.optional(Schema.Record({ key: Schema.String, value: Schema.Boolean })),
    defaultMeetingDuration: Schema.optional(Schema.Literal("15", "30", "45", "60")),
    // Maximum number of reschedules a Talent can perform for a meeting
    // Stored per recruiter and copied to each interview on creation
    maxReschedules: Schema.optional(Schema.Int),
    workingHours: Schema.optional(Schema.Array(WorkingHours)),
    uId: Schema.optional(Schema.String),
});
